import { AfterViewInit, Directive, ElementRef, HostListener, Input, inject } from '@angular/core';

@Directive({ selector: '[appAutoFocusInput]' })
export class AutoFocusInputDirective implements AfterViewInit {
  private el = inject<ElementRef<HTMLInputElement>>(ElementRef);

  @Input() row: any;
  @Input() col!: string;
  @Input() previousValue: any;
  @Input() stopEdit!: () => void;
  @Input() cancelEdit!: (row: any, col: string) => void;

  private enterPressed = false;

  ngAfterViewInit() {
    setTimeout(() => this.el.nativeElement.focus());
  }

  @HostListener('keydown.enter', ['$event'])
  handleEnter(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.enterPressed = true;
    if (this.stopEdit) {
      this.stopEdit();
    }
  }

  @HostListener('blur')
  handleBlur() {
    if (this.enterPressed) {
      // reset et ignorer le blur déclenché par Enter
      this.enterPressed = false;
      return;
    }
    if (this.stopEdit) {
      this.stopEdit();
    }
  }

  @HostListener('keydown.escape', ['$event'])
  handleEscape(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    if (this.cancelEdit) {
      this.cancelEdit(this.row, this.col);
    }
  }
}
